const ITEMS = [
  "Diritto Civile e Contrattualistica",
  "Infortunistica e Risarcimento Danni",
  "Diritto Tributario",
  "Recupero Crediti e Garanzie",
  "Consulenza Strategica",
  "Napoli · Milano",
];

const Marquee = () => (
  <div className="overflow-hidden border-y border-gold/20 bg-navy-950 py-5" data-testid="editorial-marquee">
    <div className="flex w-max animate-marquee whitespace-nowrap">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={`${item}-${i < ITEMS.length ? "a" : "b"}`} className="flex items-center">
          <span className="font-display text-lg sm:text-xl italic text-slate-300">{item}</span>
          <span className="mx-8 text-gold text-sm">§</span>
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
